<template>
  <FileView :file-id="fileId" />
</template>
<script>
import FileView from "./FileView";
import Vue from "vue";
export default {
  name: "ViewFile",
  components: { FileView },
  props: {
    fileId: {
      type: String,
      default: ""
    },
    fileName: {
      type: String,
      default: "文件预览"
    }
  },
  data() {
    return {
      isReadDownload: false,
      viewFile: ""
    };
  },
  mounted() {
    // console.log('myfielse', this.viewFile)
    Vue.directive("down", {
      inserted: (el, binding) => {
        el.style.cssText = "cursor: pointer;color:write;";
        el.addEventListener("click", () => {
          const link = document.createElement("a");
          // const url = binding.value.ViewFilePath
          var url = "/files" + binding.value.ViewFilePath.split("/files")[1];
          const name = binding.value.FileName;
          // 这里是将url转成blob地址，

          fetch(url)
            .then(res => res.blob())
            .then(blob => {
              // 将链接地址字符内容转变成blob地址
              link.href = URL.createObjectURL(blob);
              // console.log(link.href)
              link.download = name;
              document.body.appendChild(link);
              link.click();
            });
        });
      }
    });
  },
  methods: {
    returnParent() {
      this.$emit("back");
    },
    readyDowload(file) {
      this.isReadDownload = true;
      this.viewFile = file;
    }
  }
};
</script>
<style scoped lang="scss">
@import "~@/assets/styles/mcstyle.scss";
</style>
